import { SET_LOGGERS } from '../constants/actionTypes';

export const setLoggers = payload => {
  return {
    type: SET_LOGGERS,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/loggers.js